import { useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * OAuth providers redirect to root-level callback paths (e.g. /clientsso) that nginx
 * serves as the React SPA. Forward query params to the backend OAuth handler under /api/.
 */
const OAuthCallbackRedirect = ({ targetPath }) => {
  useEffect(() => {
    window.location.replace(`${targetPath}${window.location.search}`);
  }, [targetPath]);

  return null;
};

OAuthCallbackRedirect.propTypes = {
  targetPath: PropTypes.string.isRequired,
};

export default OAuthCallbackRedirect;
